// Claims info form config

import { ABI_GTA_OPTIONS, CLAIMANT_OCCUPATION_OPTIONS, METHOD_OF_NOTIFICANTION_OPTIONS, TYPE_OF_NOTIFICANTION_OPTIONS, CLAIMANT_VAT_STATUS_OPTIONS } from '../constants';

export const claimsInfoFields = [
    {
        key: 'administration',
        name: 'Administration',
        fields: [
            {
                name: 'product_line',
                label: 'Product Line',
                type: 'text',
                validation: {},
            },
            {
                name: 'claims_reference_number',
                label: 'Claims Reference Number',
                type: 'text',
                validation: {},
            },
            {
                name: 'administration_handler',
                label: 'Administration Handler',
                type: 'text',
                validation: {},
            },
            {
                name: 'live_hire_handler',
                label: 'Live Hire Handler',
                type: 'text',
                validation: {},
            },
            {
                name: 'claims_negociator',
                label: 'Claims Negotiator',
                type: 'text',
                validation: {},
            },
            {
                name: 'team_leader',
                label: 'Team Leader',
                type: 'text',
                validation: {},
            },
            {
                name: 'claims_owner',
                label: 'Claims Owner',
                type: 'text',
                validation: {},
            },
            {
                name: 'claim_owner_telephone_number',
                label: 'Claim Owner Telephone Number',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'phoneNumber' }],
            },
            {
                name: 'claim_owner_email_address',
                label: 'Claim Owner Email Address ',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'email' }],
            },
            {
                name: 'claim_received_date',
                label: 'Claim Received Date',
                type: 'date',
                validation: {},
            },
            {
                name: 'claim_creation_date',
                label: 'Claim Creation Date',
                type: 'date',
                validation: {},
            },
            {
                name: 'method_of_notification',
                label: 'Method of Notification',
                type: 'dropdown',
                dropdownOptions: METHOD_OF_NOTIFICANTION_OPTIONS,
                validation: {},
            },
            {
                name: 'type_of_notification',
                label: 'Type of Notification ',
                type: 'dropdown',
                dropdownOptions: TYPE_OF_NOTIFICANTION_OPTIONS,
                validation: {},
            },
        ],
    },
    {
        key: 'client-information',
        name: 'Client Information',
        fields: [
            {
                name: 'client',
                label: 'Client',
                type: 'text',
                validation: {},
            },
            {
                name: 'client_product_line',
                label: 'Client Product Line',
                type: 'text',
                validation: {},
            },
            {
                name: 'client_office_location',
                label: 'Client Office Location',
                type: 'text',
                validation: {},
            },
            {
                name: 'client_handler',
                label: 'Client Handler',
                type: 'text',
                validation: {},
            },
            {
                name: 'client_contact_number',
                label: 'Client Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'phoneNumber' }],
            },
            {
                name: 'client_email_address',
                label: 'Client Email Address',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'email' }],
            },
            {
                name: 'client_policy_number',
                label: 'Client Policy Number',
                type: 'text',
                validation: {},
            },
            {
                name: 'client_claims_ref_nb',
                label: 'Client Claims Reference Number',
                type: 'text',
                validation: {},
            },
            {
                name: 'client_claims_system_ref_nb',
                label: 'Client Claims System Reference Number',
                type: 'text',
                validation: {},
            },
            {
                name: 'client_abi_gta_status',
                label: 'Client ABI GTA Status',
                type: 'dropdown',
                dropdownOptions: ABI_GTA_OPTIONS,
                validation: {},
            },
        ],
    },
    {
        key: 'parties-information',
        name: 'Parties Information',
        fields: [
            {
                name: 'defendant_name',
                label: 'Defendant Name',
                type: 'text',
                validation: {},
            },
            {
                name: 'defendant_ph_name',
                label: 'Defendant PH Name',
                type: 'text',
                validation: {},
            },
            {
                name: 'defendant_address',
                label: 'Defendant Address',
                type: 'text',
                validation: {},
            },
            {
                name: 'defendant_postcode',
                label: 'Defendant Post Code',
                type: 'text',
                validation: {},
            },
            {
                name: 'defendant_contact_number',
                label: 'Defendant Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'phoneNumber' }],
            },
            {
                name: 'claimant_name',
                label: 'Claimant Name',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_ph_name',
                label: 'Claimant PH Name',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_dob',
                label: 'Claimant Date of Birth',
                type: 'date',
                validation: [{ name: 'required' }],
            },
            {
                name: 'date_of_licence',
                label: 'Claimant Date of Licence',
                type: 'date',
                validation: [{ name: 'required' }],
            },
            {
                name: 'claimant_first_language',
                label: 'Claimant First Language',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_understands_english',
                label: 'Claimant Understands English?',
                type: 'boolean',
                validation: [{ name: 'required' }],
            },
            {
                name: 'claimant_address',
                label: 'Claimant Address',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_postcode',
                label: 'Claimant Post Code',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_contact_number',
                label: 'Claimant Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'phoneNumber' }],
            },
            {
                name: 'claimant_vat_status',
                label: 'Claimant VAT Status',
                type: 'dropdown',
                dropdownOptions: CLAIMANT_VAT_STATUS_OPTIONS,
                validation: [{ name: 'required' }],
                modalValidation: [{ name: 'required' }],
            },
            {
                name: 'claimant_vat_percent',
                label: 'Claimant VAT %',
                type: 'float',
                validation: [{ name: 'required' }, {name: 'float'}, {name: 'min', params: {value: 0}}, {name: 'max', params: {value: 100}}],
                modalValidation: [{ name: 'required' }, {name: 'float'}, {name: 'min', params: {value: 0}}, {name: 'max', params: {value: 100}}],
            },
            {
                name: 'claimant_ivr_or_bankrupt',
                label: 'Claimant IVR/Bankrupt?',
                type: 'boolean',
                validation: [{ name: 'required' }],
            },
            {
                name: 'claimant_insurer',
                label: 'Claimant Insurer',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_insurer_policy_nb',
                label: 'Claimant Insurer Policy Number',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_insurer_claims_ref_nb',
                label: 'Claimant Insurer Claims Reference Number',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_insurance_policy_cover_level',
                label: 'Claimant Insurance Policy Cover Level',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_insurer_policy_fleet_cover',
                label: 'Claimant insurer policy fleet cover?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'claimant_insurer_reported_date',
                label: 'Claimant Insurer reported date',
                type: 'date',
                validation: {},
            },
            {
                name: 'claimant_insurer_contact_number',
                label: 'Claimant Insurer Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'phoneNumber' }],
            },
            {
                name: 'claimant_insurer_address',
                label: 'Claimant Insurer Address',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_insurer_email',
                label: 'Claimant Insurer Email',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'email' }],
            },
            {
                name: 'claimant_licence_type',
                label: 'Claimant Licence Type',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_occupation',
                label: ' Claimant Occupation',
                type: 'custom-select',
                customOptions: CLAIMANT_OCCUPATION_OPTIONS,
                validation: [{ name: 'required' }],
            },
            {
                name: 'additional_driver_1_name',
                label: 'Additional Driver 1 Name',
                type: 'text',
                validation: {},
            },
            {
                name: 'additional_driver_1_address',
                label: 'Additional Driver 1 Address',
                type: 'text',
                validation: {},
            },
            {
                name: 'additional_driver_1_postcode',
                label: 'Additional Driver 1 Postcode',
                type: 'text',
                validation: {},
            },
            {
                name: 'additional_driver_1_occupation',
                label: 'Additional Driver 1 Occupation',
                type: 'custom-select',
                customOptions: CLAIMANT_OCCUPATION_OPTIONS,
                validation: {},
            },
            {
                name: 'additional_driver_1_contact_number',
                label: 'Additional Driver 1 Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'phoneNumber' }],
            },
            {
                name: 'additional_driver_1_dob',
                label: 'Additional Driver 1 Date of Birth',
                type: 'date',
                validation: {},
            },
            {
                name: 'additional_driver_1_licence_type',
                label: 'Additional Driver 1 Licence Type',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'coverage-information',
        name: 'Coverage Information',
        fields: [
            {
                name: 'accident_date',
                label: 'Accident Date',
                type: 'date',
                changesOtherFieldsValues: true,
                validation: [{ name: 'required' }],
            },
            {
                name: 'accident_time',
                label: 'Accident Time',
                type: 'text',
                validation: {},
            },
            {
                name: 'accident_location',
                label: 'Accident Location',
                type: 'text',
                validation: {},
            },
            {
                name: 'accident_type',
                label: 'Accident Type',
                type: 'text',
                validation: {},
            },
            {
                name: 'accident_circumstance',
                label: 'Accident Circumstance',
                type: 'text',
                validation: {},
            },
            {
                name: 'liability_status',
                label: 'Liability Status',
                type: 'text',
                validation: {},
            },
            {
                name: 'liability_position',
                label: 'Liability Position',
                type: 'text',
                validation: {},
            },
            {
                name: 'liability_proportion_defendant',
                label: 'Liability Proportion - Defendant',
                type: 'integer',
                validation: {},
            },
            {
                name: 'liability_proportion_claimant',
                label: 'Liability Proportion - Claimant',
                type: 'integer',
                validation: {},
            },
            {
                name: 'indemnity_status_defendant',
                label: 'Indemnity Status - Defendant',
                type: 'text',
                validation: {},
            },
            {
                name: 'indemnity_status_claimant',
                label: 'Indemnity Status - Claimant',
                type: 'text',
                validation: {},
            },
            {
                name: 'indemnity_granted_date_claimant',
                label: 'Indemnity granted date - Claimant',
                type: 'date',
                validation: {},
            },
            {
                name: 'reservation_of_rights_obtained',
                label: 'Assignment & Agreement/ Reservation of Rights obtained?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'offer_intervention',
                label: 'Offer Intervention',
                type: 'text',
                validation: {},
            },
            {
                name: 'is_impec_pleaded',
                label: 'Is Impec being pleaded?',
                type: 'boolean',
                validation: {},
            },
        ],
    },
    {
        key: 'moj-information-1',
        name: 'MOJ Information (1)',
        fields: [
            {
                name: 'claim_presented_on_moj',
                label: 'Claim Presented on MOJ',
                type: 'boolean',
                dependencySource: true,
                dependencyMatchValue: 1,
                validation: {},
            },
            {
                name: 'claim_status_on_moj',
                label: 'Claim Status on MOJ',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_moj',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'date_claim_presented_moj',
                label: 'Date Claim Presented',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_moj',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'stage_claim_presented_moj',
                label: 'Stage Claim Presented',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_moj',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'stage2_received_date',
                label: 'Stage 2 Received Date',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_moj',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'date_for_response_moj',
                label: 'Date for Response',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_moj',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'date_response_provided_moj',
                label: 'Date Response Provided',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_moj',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'stage_3_part_8_proceeding_received',
                label: 'Stage 3/ Part 8 Proceedings Received',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_moj',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'stage_3_part_8_proceeding_date_of_hearing',
                label: 'Stage 3/ Part 8 Proceedings Date of Hearing',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_moj',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'stage_3_part_8_proceeding_outcome',
                label: 'Stage 3/ Part 8 Proceedings Outcome',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_moj',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
        ],
    },
    {
        key: 'moj-information-2',
        name: 'MOJ Information (2)',
        fields: [
            {
                name: 'claim_presented_on_oic',
                label: 'Claim Presented on OIC',
                type: 'boolean',
                dependencySource: true,
                dependencyMatchValue: 1,
                validation: {},
            },
            {
                name: 'date_claim_presented_oic',
                label: 'Date Claim Presented',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_oic',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'stage_claim_presented_oic',
                label: 'Stage Claim Presented',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_oic',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'nvc_received_date',
                label: 'NVC Received Date',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_oic',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'date_for_response_oic',
                label: 'Date for Response',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_oic',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'date_response_provided_oic',
                label: 'Date Response Provided',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_oic',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'part_7_proceeding_received',
                label: 'Part 7 Proceedings Received',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_oic',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'part_7_date_of_hearing',
                label: 'Party 7 Date of Hearing',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_oic',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'part_7_outcome',
                label: 'Part 7 Outcome',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claim_presented_on_oic',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
        ],
    },
    {
        key: 'finance-billing-information',
        name: 'Finance / Billing Information',
        fields: [
            {
                name: 'final_invoice_to_be_requested',
                label: 'Final Invoice to be requested?',
                type: 'float',
                validation: {},
            },
            {
                name: 'fee_amount',
                label: 'Fee Amount',
                type: 'float',
                validation: {},
            },
            {
                name: 'any_disbursements',
                label: 'Any Disbursements?',
                type: 'text',
                validation: {},
            },
            {
                name: 'engineers_service',
                label: 'Engineers Service',
                type: 'float',
                validation: {},
            },
            {
                name: 'recovery_services',
                label: 'Recovery Services',
                type: 'float',
                validation: {},
            },
            {
                name: 'storage_inherited_charges',
                label: 'Storage (inherited charges)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair',
                label: 'Repair',
                type: 'float',
                validation: {},
            },
            {
                name: 'basic_hire_rate_provision',
                label: 'Basic Hire Rate Provision',
                type: 'float',
                validation: {},
            },
            {
                name: 'any_other_disbursements',
                label: 'Any Other Disbursements',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_disbursements_amounts',
                label: 'Total Disbursements Amounts',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_amount_requested',
                label: 'Total Amount Requested',
                type: 'float',
                validation: {},
            },
            {
                name: 'email_address_for_invoice_to_be_sent',
                label: 'Email Address for Invoice to be sent.',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'email' }],
            },
            {
                name: 'date_invoice_generated',
                label: 'Date Invoice Generated',
                type: 'date',
                validation: {},
            },
            {
                name: 'date_invoice_paid',
                label: 'Date Invoice Paid',
                type: 'date',
                validation: {},
            },
            {
                name: 'number_of_days_allowed_to_pay',
                label: 'Number of Days Allowed to Pay',
                type: 'integer',
                validation: {},
            },
        ],
    },
];
